import { BracketType, BracketTypeList, CANVAS_SIZE_MAX, CANVAS_SIZE_MIN, CANVAS_ZOOM_MAX, CANVAS_ZOOM_MIN, CanvasType, CanvasTypeList, ColumnType, ColumnTypeList, DDLScriptPosition, DDLScriptPositionList, Database, DatabaseList, InvertedLockSettings, Language, LanguageList, LockSettingFields, LockSettingType, LockSettingTypeList, NameCase, NameCaseList, NameViewMode, NameViewModeList, Show } from "./settings.js";
import { OrderType, OrderTypeList } from "./indexColumn.entity.js";
import { Direction, DirectionList, ReferentialAction, ReferentialActionList, RelationshipType, RelationshipTypeList, StartRelationshipType, StartRelationshipTypeList } from "./relationship.entity.js";
import { ColumnOption, ColumnUIKey } from "./tableColumn.entity.js";
//#region ../erd-editor-schema/dist/v3/schema/index.js
var SchemaV3Constants = {
	CanvasType,
	CanvasTypeList,
	Show,
	ColumnType,
	ColumnTypeList,
	Database,
	DatabaseList,
	Language,
	LanguageList,
	NameCase,
	NameCaseList,
	BracketType,
	BracketTypeList,
	RelationshipType,
	RelationshipTypeList,
	StartRelationshipType,
	StartRelationshipTypeList,
	ReferentialAction,
	ReferentialActionList,
	Direction,
	DirectionList,
	ColumnOption,
	ColumnUIKey,
	OrderType,
	OrderTypeList,
	LockSettingType,
	LockSettingTypeList,
	LockSettingFields,
	CANVAS_SIZE_MAX,
	CANVAS_SIZE_MIN,
	CANVAS_ZOOM_MAX,
	CANVAS_ZOOM_MIN,
	DDLScriptPosition,
	DDLScriptPositionList,
	NameViewMode,
	NameViewModeList,
	InvertedLockSettings
};
//#endregion
export { SchemaV3Constants };
